export const screeningResultsState = {
  schoolGrade: undefined,
  testTime: undefined,
  education: undefined,
  germanSecondaryLanguage: undefined,
  screenResultsEstimated: undefined,
  screeningResultReading: undefined,
  screeningResultWriting: undefined,
  screeningResultCounting: undefined,
  categoriesReadingOptions: undefined,
  categoriesWritingOptions: undefined,
  categoriesCountingOptions: undefined,
  options: '',
  age: '',
  value: '',
  readingK1Results: '',
  readingK2Results: '',
  readingK3Results: '',
  readingK4Results: '',
  writingK1Results: '',
  writingK2Results: '',
  writingK3Results: '',
  writingK4Results: '',
  countingK1Results: '',
  countingK2Results: '',
  countingK3Results: '',
  countingK4Results: '',
};

export const questionnaireState = {
  helping: null,
  complication: null,
  efficiency: null,
  simplicity: null,
  exciting: null,
  interest: null,
  originality: null,
  novelty: null,
  usability: null,
  occupation: null,
};
